import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/productCategories'
import Component from 'components/ProductCategories'

export default createListViewContainer({ actions, selectors: selectors.productCategories })(Component)
